import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div
            data-testid="not-found-page"
            className="min-h-screen bg-[#F7F5F0] text-[#0F1F38] flex items-center justify-center px-6"
        >
            <div className="max-w-lg">
                <div className="text-[10px] tracking-label uppercase text-[#0F1F38]/50 mb-4">
                    Error · 404
                </div>
                <h1 className="font-display text-5xl md:text-7xl leading-[1] text-[#0F1F38]">
                    Not found.
                </h1>
                <p className="mt-6 text-[#0F1F38]/70">
                    The page you were looking for doesn&apos;t exist — or was moved.
                </p>
                <Link
                    to="/"
                    data-testid="not-found-home"
                    className="mt-10 inline-flex items-center gap-3 px-6 py-4 bg-[#0F1F38] text-[#F7F5F0] text-xs tracking-label uppercase font-semibold hover:bg-[#1A3254] transition-colors duration-200"
                >
                    Back to home
                </Link>
            </div>
        </div>
    );
}
